// imports

// statics
export const MODEL_EVENTS = 'response,change,locked,unlocked,cleared,error';
export const COLLECTION_EVENTS = 'response,add,remove,change';
export const MC_EVENTS = [MODEL_EVENTS, COLLECTION_EVENTS].join(',');
